/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/64/loader': {
    width: 64,
    height: 64,
    viewBox: '0 0 64 64',
    data: '<path pid="0" d="M5.258 45.613a29.893 29.893 0 01-3.221-12.129c-.82-16.548 11.93-30.628 28.479-31.447 16.548-.82 30.628 11.93 31.447 28.479.82 16.548-11.93 30.628-28.479 31.447a29.877 29.877 0 01-19.354-5.865" _stroke="#272727" stroke-width="4" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
